<template>
  <StationSelectModal
    ref="stationSelectRef"
    :display-id="DISPLAY_ID"
    title="マップの表示駅を選択"
    decide-btn-label="駅エリアマップ表示"
    @station-selected="showStationMap"
    @canceled="$emit('canceled')"
  />
</template>

<script setup lang="ts">
import StationSelectModal from './StationSelectModal.vue';
import type { StationWithOrganization } from '~/types/common/stationWithOrganization';

const DISPLAY_ID = 'C-05';

const { openStationMapPdfInNewTab } = useFile(DISPLAY_ID);

const stationSelectRef = ref<InstanceType<typeof StationSelectModal>>();

defineEmits<{
  canceled: [];
}>();

/**
 * 駅マップを表示する
 */
const showStationMap = async (selectedStation: StationWithOrganization) => {
  await openStationMapPdfInNewTab(selectedStation.stationCd, selectedStation.stationSubCd);
  close();
};

/**
 * モーダルを開く
 */
const open = async () => {
  if (stationSelectRef.value) {
    await stationSelectRef.value.openModal();
  }
};

/**
 * モーダルを閉じる
 */
const close = () => {
  if (stationSelectRef.value) {
    stationSelectRef.value.closeModal();
  }
};

defineExpose({
  open,
  close,
});
</script>

<style lang="scss" scoped>
label {
  font-size: 20px;
  font-weight: bold;
}
</style>
